export default __webpack_public_path__ + "static/media/pdf-menu.04e0029a.png";